import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Phone, Globe } from 'lucide-react';
interface AgencyPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function AgencyPopup({
  isOpen,
  onClose
}: AgencyPopupProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-19">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-zinc-900/40 backdrop-blur-sm z-50" data-id="element-20" />
          <div className="fixed inset-0 flex items-center justify-center z-50 px-4 pointer-events-none" data-id="element-21">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-white rounded-[2rem] p-8 md:p-10 max-w-md w-full relative pointer-events-auto border border-zinc-100 shadow-2xl" data-id="element-22">
              <button onClick={onClose} className="absolute top-6 right-6 p-2 text-zinc-400 hover:text-zinc-900 bg-zinc-50 hover:bg-zinc-100 rounded-full transition-colors" data-id="element-23">
                <X className="w-4 h-4" data-id="element-24" />
              </button>

              <div className="w-12 h-12 bg-zinc-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-25">
                <Globe className="w-5 h-5 text-zinc-900" data-id="element-26" />
              </div>

              <h3 className="text-2xl font-semibold text-zinc-900 mb-3 tracking-tight" data-id="element-27">
                Розробка сайтів
              </h3>

              <p className="text-zinc-500 mb-8 font-light leading-relaxed" data-id="element-28">
                Ми можемо створити такий сайт для вас під ключ, адаптувати під
                ваші потреби. Вартість розробки —{' '}
                <span className="font-medium text-zinc-900" data-id="element-29">8 000 грн</span>.
              </p>

              <div className="flex flex-col gap-3" data-id="element-30">
                <a href="tel:+380508399309" className="flex items-center gap-4 p-4 rounded-2xl bg-zinc-50 hover:bg-zinc-100 transition-colors group" data-id="element-31">
                  <div className="w-10 h-10 rounded-full bg-white border border-zinc-200 flex items-center justify-center text-zinc-600 group-hover:text-zinc-900 transition-colors" data-id="element-32">
                    <Phone className="w-4 h-4" data-id="element-33" />
                  </div>
                  <div data-id="element-34">
                    <div className="text-xs text-zinc-500 font-medium mb-0.5" data-id="element-35">
                      Зателефонувати
                    </div>
                    <div className="font-medium text-zinc-900" data-id="element-36">
                      +380 50 839 93 09
                    </div>
                  </div>
                </a>

                <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-2xl bg-zinc-50 hover:bg-zinc-100 transition-colors group" data-id="element-37">
                  <div className="w-10 h-10 rounded-full bg-white border border-zinc-200 flex items-center justify-center text-zinc-600 group-hover:text-zinc-900 transition-colors" data-id="element-38">
                    <Globe className="w-4 h-4" data-id="element-39" />
                  </div>
                  <div data-id="element-40">
                    <div className="text-xs text-zinc-500 font-medium mb-0.5" data-id="element-41">
                      Наш сайт
                    </div>
                    <div className="font-medium text-zinc-900" data-id="element-42">
                      jetly.agency/ua
                    </div>
                  </div>
                </a>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}